import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Tabs, Tab } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import InstrctorTab from "./Tabs/InstructorTab";
import InstructorsApprovalsTab from "./Tabs/InstructorsApprovalsTab";
import { authActions, centersActions } from "../../../../redux/actions";
import { translationConstants } from "../../../../constants";

const tab = { instructor: "instructorTab", approval: "approvalTab" };

const Instructors = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(tab.instructor);

  useEffect(() => {
    dispatch(authActions.fetchCountries());
    dispatch(centersActions.getAllCentersList());
    // eslint-disable-next-line
  }, []);

  return (
    <div className="UserDiv">
      <p className="UserTabHeading">{t(translationConstants.instructor)}</p>
      <div className="tabsDiv">
        <Tabs
          className="mr-0"
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
        >
          <Tab
            eventKey={tab.instructor}
            title={t(translationConstants.instructorList)}
          >
            {activeTab === tab.instructor && <InstrctorTab />}
          </Tab>
          <Tab eventKey={tab.approval} title={t(translationConstants.approval)}>
            {activeTab === tab.approval && <InstructorsApprovalsTab />}
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

export default Instructors;
